import { defineStore } from "pinia";

export const useConfirmStore = defineStore("confirm", {
  state: () => ({
    visible: false as boolean,
    title: "" as string,
    message: "" as string,
    confirmText: "确定" as string,
    cancelText: "取消" as string,
    onConfirm: null as (() => void) | null,
    onCancel: null as (() => void) | null,
  }),
  actions: {
    showConfirm(
      message: string,
      title = "确认",
      confirmText = "确定",
      cancelText = "取消",
      onConfirm?: () => void,
      onCancel?: () => void
    ) {
      this.title = title;
      this.message = message;
      this.confirmText = confirmText;
      this.cancelText = cancelText;
      this.onConfirm = onConfirm || null;
      this.onCancel = onCancel || null;
      this.visible = true;
    },
    hideConfirm() {
      this.visible = false;
      this.onConfirm = null;
      this.onCancel = null;
    },
    handleConfirm() {
      if (this.onConfirm) {
        this.onConfirm();
      }
      this.hideConfirm();
    },
    handleCancel() {
      if (this.onCancel) {
        this.onCancel();
      }
      this.hideConfirm();
    },
  },
});
